import { ToolbarInteractionModes } from '../types/toolbar-interaction-modes.js';
import { A11yToolbarTabIndex } from '../types/toolbar.js';

/**
 * Get key from ToolbarTabIndex [key]: number
 * @param tabIndex - toolbar control tab index [key]: number
 * @internal
 */
export function getTabIndexValue(tabIndex: A11yToolbarTabIndex): number {
  return Object.values(tabIndex)[0];
}

/**
 * Get value from ToolbarTabIndex [key]: number
 *
 * @internal
 * @param tabIndex - toolbar control tab index [key]: number
 */
export function getTabIndexKey(
  tabIndex: A11yToolbarTabIndex,
): ToolbarInteractionModes {
  return Object.keys(tabIndex)[0] as ToolbarInteractionModes;
}

/**
 * The arrow keys handleControls accepts
 */
export type ArrowDirection = 'ArrowLeft' | 'ArrowRight';

/**
 * Modify the controls depending on the param direction:
 * Left (-1) or right (+1), will modify the next tabIndex control.
 *
 * @param direction - ArrowDirection, only accepts AerrowLeft | ArrowRight
 * @param controls - All toolbar buttons as array of objects [key]: number
 */
export function handleControls(
  direction: ArrowDirection,
  controls: A11yToolbarTabIndex[],
): A11yToolbarTabIndex[] {
  const newControls = [...controls];
  const controlIndex = controls.findIndex(
    (c: A11yToolbarTabIndex) => getTabIndexValue(c) === 0,
  );

  const isRightLastControl =
    direction === 'ArrowRight' && controlIndex === newControls.length - 1;
  const isLeftFirstControl = direction === 'ArrowLeft' && controlIndex === 0;

  if (isLeftFirstControl || isRightLastControl) {
    return newControls;
  }
  const nextControlIndex =
    direction === 'ArrowLeft' ? controlIndex - 1 : controlIndex + 1;

  const currentControl = newControls[controlIndex];
  const nextControl = newControls[nextControlIndex];

  newControls[controlIndex] = { [getTabIndexKey(currentControl)]: -1 };
  newControls[nextControlIndex] = { [getTabIndexKey(nextControl)]: 0 };

  return newControls;
}
